import { render, staticRenderFns } from "./LongReadController.vue?vue&type=template&id=2930e68d&"
import script from "./LongReadController.vue?vue&type=script&lang=js&"
export * from "./LongReadController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports